import { render } from "./TheWorkspace.vue?vue&type=template&id=b3ba10e2"
const script = {}
script.render = render

export default script